<script>
    import R, {LOADER} from "../lib/requests";
    import {CHECKIN_STATUS} from "../lib/constants.js";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import PageHeader from "../components/PageHeader.svelte";
    import PageNotFound from "../components/pages/PageNotFound.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import CheckInData from "./CheckInData.svelte";

    export let checkinId;

    let checkin = null;
    let member = null;
    let hotel = null;
    let errorMessage = null;
    let checkinStatusId = null;
    let newStatusId = null;
    let isDirty = false;

    const breadcrumb = [
        {id: 'checkins', name: 'Check Ins', link: `/app/checkins`}
    ];

    const load = () => {
        const onSuccess = result => {
            checkin = result;
            member = checkin.member;
            hotel = checkin.hotel;
            newStatusId = ~~checkin.status_id;
        }

        const onFailure = err => {
            errorMessage = "member check in not found!";
        };

        R.handle(R.checkin.details, checkinId, onSuccess, onFailure, LOADER.PAGE);
    }


    const onUpdate = () => {
        if (checkin.status_id != newStatusId) {
            let prompt = null;

            if (newStatusId == CHECKIN_STATUS.CONFIRMED) {
                Alert.confirm("Confirm check in", `Confirm check in from member <b>${member.lastname} ${member.firstname}</b>?`, save);
                return;
            } else if (newStatusId == CHECKIN_STATUS.REFUSED) {
                if (checkin.points) {
                    prompt = `\n<b>This will remove ${checkin.points} points from member!</b>`;
                }
                Alert.confirm("Reject check in", `Reject check in from member <b>${member.lastname} ${member.firstname}</b>?${prompt}`, save);
                return;
            }
        }

        save();
    }

    const save = () => {
        const onSuccess = result => {
            checkin.status_id = result.status_id;
            checkinStatusId = result.status_id;
            if (checkin.status_id == CHECKIN_STATUS.CONFIRMED) {
                checkin.points = result.points;
            }
            isDirty = false;
            Notifier.showMessage("Check in updated");
        }

        const onFailure = err => {
            if (err.code === 'not_found') {
                Alert.warning("Confirm check in", "Could not find check in data!");
                return;
            }
            if (err.code === 'overlap') {
                Alert.warning("Confirm check in", "There is already a confirmed check in of this member on these dates!");
            }
        };

        let data = {
            id: checkin.id,
            date_in: checkin.date_in,
            date_out: checkin.date_out,
            status_id: newStatusId
        }

        R.handle(R.checkin.edit, data, onSuccess, onFailure, LOADER.POPUP);
    }

    const onChange = () => {
        isDirty = true;
    }


    load();
</script>

<Breadcrumb {breadcrumb}/>
<PageHeader title="Member Check in Details"/>
{#if checkin}
    <h2 class="mb-2">{ hotel.name }</h2>
    <h5 class="mb-4">{ member.lastname } { member.firstname }</h5>
    <div class="row">
        <div class="col-xl-6 col-lg-10 col-md-12">
            <CheckInData {checkin} on:change={ onChange }/>

            <div class="panel-simple panel-pad mb-4">
                <div class="form-group">
                    <label>Status</label>
                    <select class="form-select" bind:value="{ newStatusId }" on:change={ onChange }>
                        {#if checkin.status_id == CHECKIN_STATUS.NEW}
                            <option value="{ CHECKIN_STATUS.NEW }">New</option>
                        {/if}
                        <option value="{ CHECKIN_STATUS.CONFIRMED }">Confirmed</option>
                        <option value="{ CHECKIN_STATUS.REFUSED }">Rejected</option>
                    </select>
                </div>
            </div>

            {#if checkinStatusId == CHECKIN_STATUS.CONFIRMED}
                <div class="alert alert-info alert-with-icon mb-4">
                    <div class="alert-icon">
                        <AppIcon icon="check" strokeWidth="2" size="24"/>
                    </div>
                    <div class="alert-content">
                        Check in has been confirmed!<br>
                        { checkin.points } points added to member.
                    </div>
                </div>
            {:else if checkinStatusId == CHECKIN_STATUS.REFUSED}
                <div class="alert alert-danger alert-with-icon mb-4">
                    <div class="alert-icon">
                        <AppIcon icon="x" strokeWidth="2" size="24"/>
                    </div>
                    <div class="alert-content">
                        Check in has been rejected!
                        {#if checkin.points}
                            <br>{ checkin.points } points removed from member.
                        {/if}
                    </div>
                </div>
            {/if}

            <div class="text-end">
                <button class="btn btn-primary px-4" on:click={ onUpdate } disabled="{ !isDirty }">UPDATE</button>
            </div>
        </div>
    </div>
{/if}
{#if errorMessage}
    <PageNotFound message="{ errorMessage }"/>
{/if}
